import { createAction } from 'redux-actions';

import { createActionBundle } from 'utilities/request';

export const {
  fetch: fetchReportItem,
  request: requestReportItem,
  success: requestReportItemSuccess,
  failure: requestReportItemFailure,
} = createActionBundle('REPORT_ITEM');

export const {
  request: requestReportAttachment,
  success: requestReportAttachmentSuccess,
  failure: requestReportAttachmentFailure,
} = createActionBundle('REPORT_ATTACHMENT');

export const reportsSetObservation = createAction('REPORTS/SET_OBSERVATION');

export const reportsDownloadPdf = createAction('REPORTS/DOWNLOAD_PDF');
export const downloadDocumentReferencePdf = createAction('REPORTS/DOWNLOAD_DOCUMENT_REFERENCE_PDF');

export const reportsMarkAsRead = createAction('REPORTS/MARK_AS_READ');
export const deleteReport = createAction('REPORTS/DELETE');
export const deleteCardioVascularReport = createAction('REPORTS/DELETE_CARDIO_VASCULAR_REPORT');

export const reportsSubmitDetailedEpForm = createAction('REPORTS/SUBMIT_DETAILED_EP_FORM');

export const reportsSubmitDeviceInfoForm = createAction('REPORTS/SUBMIT_DEVICE_INFO_FORM');
